import React from "react";
import { formatDateTime, formatText } from "../../utils/formatters";

// (2026-05-15) Rediseño Sirius. Antes el modal usaba el patrón viejo
// (panel w-[75%] h-[90%] + lista <p><strong>) y footer .absolute.bottom-4.
// Reescrito al patrón estándar (overlay → panel redondeado → header /
// body scroll / footer en flujo) con los datos en tarjetas `Item`.
// Toda la lógica/bindings de `companyUser` se conserva idéntica, incluido
// el gating de integrador y el mapa de rol (fix visor→AUDITOR).
function ModalCompanyUsers({ isOpen, onClose, companyUser }) {
  if (!isOpen || !companyUser) return null;

  // (2026-05-13) Misma logica que FormCompanyUsers: bloque de integrador
  // visible solo para admin/auditor, y los 3 campos dependientes
  // (aplicativo, version_app, origen) solo se muestran si es_integrador=true.
  const authData = localStorage.getItem("authData");
  const rolActual = authData ? JSON.parse(authData)["rol"] : "";
  const puedeVerIntegrador = rolActual === "admin" || rolActual === "auditor";

  // (2026-05-15) Bug: el caso comparaba con 'Visor' (mayúscula) pero el
  // valor real es 'visor' -> un visor caía al fallback y se mostraba como
  // "Auditor". Se usa un mapa explícito.
  const rolLabel =
    ({
      operador: "Operador",
      operador_admin: "Operador Admin",
      visor: "Visor",
      admin: "Administrador",
      auditor: "Auditor",
    }[companyUser.rol]) || companyUser.rol || "—";

  const Item = ({ label, children, full }) => (
    <div className={full ? "w-full" : "w-full sm:w-1/2 lg:w-1/3"}>
      <div className="bg-slate-50/70 rounded-xl border border-slate-200/70 p-4 h-full">
        <h3 className="text-[11px] uppercase tracking-[0.12em] font-semibold text-ink-500 mb-1.5">{label}</h3>
        <div className="text-sm font-medium text-ink-900 break-words">{children}</div>
      </div>
    </div>
  );

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-black/50">
      <div className="bg-white rounded-2xl shadow-sirius-lg w-full max-w-[1100px] max-h-[90vh] flex flex-col overflow-hidden">
        {/* HEADER */}
        <div className="px-6 md:px-8 py-5 border-b border-slate-200 bg-white">
          <h6 className="text-lg md:text-xl font-display font-bold text-ink-900 text-center">
            Detalles de Usuario
          </h6>
        </div>

        {/* BODY */}
        <div className="flex-1 min-h-0 overflow-y-auto px-6 md:px-8 py-6">
          <div className="flex flex-wrap gap-3">
            <Item label="Fecha de creación">{formatDateTime(companyUser.created_at) || "—"}</Item>
            <Item label="Nombre">{formatText(companyUser.nombre) || "—"}</Item>
            <Item label="Correo electrónico">{formatText(companyUser.email) || "—"}</Item>
            <Item label="Cambio de contraseña">
              {companyUser.must_change_password ? (
                <span className="inline-block bg-amber-500 text-white py-1 px-3 rounded-full text-xs font-bold">SI</span>
              ) : (
                <span className="inline-block bg-emerald-500 text-white py-1 px-3 rounded-full text-xs font-bold">NO</span>
              )}
            </Item>
            <Item label="Rol">{formatText(rolLabel)}</Item>
          </div>

          {/* (2026-05-20) Bloque con header propio: Datos de la Empresa
              asociada al usuario — visible solo para admin/auditor. */}
          {puedeVerIntegrador && (
            <>
              <h3 className="text-[11px] uppercase tracking-[0.12em] font-semibold text-ink-400 mt-5 mb-3">
                Datos de la Empresa
              </h3>
              <div className="flex flex-wrap gap-3">
                {companyUser.cliente ? (
                  <>
                    <Item label="RIF">{formatText(companyUser.cliente.rif || "—")}</Item>
                    <Item label="Empresa">{formatText(companyUser.cliente.nombre_empresa || "—")}</Item>
                  </>
                ) : (companyUser.rol === 'admin' || companyUser.rol === 'auditor') ? (
                  <Item label="Empresa" full>
                    <span className="italic text-ink-500">Usuario interno (Optimus Invoice)</span>
                  </Item>
                ) : null}
              </div>
            </>
          )}

          {/* Integración — visible solo para admin/auditor */}
          {puedeVerIntegrador && (
            <>
              <h3 className="text-[11px] uppercase tracking-[0.12em] font-semibold text-ink-400 mt-7 mb-3">Integración</h3>
              <div className="flex flex-wrap gap-3">
                <Item label="Es Integrador">
                  {companyUser.es_integrador ? (
                    <span className="inline-block bg-twilight-indigo-100 text-twilight-indigo-700 py-1 px-3 rounded-full text-xs font-bold">SI</span>
                  ) : (
                    <span className="inline-block bg-slate-200 text-ink-700 py-1 px-3 rounded-full text-xs font-bold">NO</span>
                  )}
                </Item>
                {companyUser.es_integrador && (
                  <>
                    <Item label="Aplicativo">{formatText(companyUser.aplicativo || "—")}</Item>
                    <Item label="Versión App">{formatText(companyUser.version_app || "—")}</Item>
                    <Item label="Origen permitido">
                      {companyUser.origen ? formatText(companyUser.origen) : "— (sin restricción)"}
                    </Item>
                  </>
                )}
              </div>
            </>
          )}
        </div>

        {/* FOOTER */}
        <div className="shrink-0 w-full flex justify-center py-4 border-t border-slate-200 bg-white">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-twilight-indigo-600 hover:bg-twilight-indigo-500 text-white font-semibold rounded-xl transition"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalCompanyUsers;
